import { render, staticRenderFns } from "./CreateRecipeForm.vue?vue&type=template&id=28b0fc7c&scoped=true&"
import script from "./CreateRecipeForm.vue?vue&type=script&lang=ts&"
export * from "./CreateRecipeForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateRecipeForm.vue?vue&type=style&index=0&id=28b0fc7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b0fc7c",
  null
  
)

export default component.exports